/* Formas Home · selector Boleta / Factura del carrito (snippets/fh-comprobante.liquid) */
(function () {
  if (window.__fhComprobante) return;
  window.__fhComprobante = true;

  var KEYS = ['RUC', 'Razón social', 'Dirección fiscal'];
  var estado = null;   // lo último que eligió el cliente en esta visita
  var timer = null;

  function rucValido(r) {
    if (!/^(10|15|17|20)\d{9}$/.test(r)) return false;
    var w = [5, 4, 3, 2, 7, 6, 5, 4, 3, 2], s = 0;
    for (var i = 0; i < 10; i++) s += +r.charAt(i) * w[i];
    var d = 11 - (s % 11);
    if (d === 10) d = 0; else if (d === 11) d = 1;
    return d === +r.charAt(10);
  }

  function campo(box, k) { return box.querySelector('[data-fh-key="' + k + '"]'); }

  function leer(box) {
    var r = box.querySelector('input[type="radio"]:checked');
    var o = { tipo: r ? r.value : 'Boleta' };
    KEYS.forEach(function (k) { var i = campo(box, k); o[k] = i ? i.value.trim() : ''; });
    return o;
  }

  function aplicarTipo(box, tipo) {
    var fac = tipo === 'Factura';
    var zona = box.querySelector('[data-fh-factura]');
    if (zona) zona.hidden = !fac;
    KEYS.forEach(function (k) { var i = campo(box, k); if (i) i.disabled = !fac; });
    box.querySelectorAll('[data-fh-blank]').forEach(function (i) { i.disabled = fac; });
    if (!fac) limpiarError(box);
  }

  function pintar(box, o) {
    box.querySelectorAll('input[type="radio"]').forEach(function (r) { r.checked = r.value === o.tipo; });
    KEYS.forEach(function (k) { var i = campo(box, k); if (i && o[k] !== undefined) i.value = o[k]; });
    aplicarTipo(box, o.tipo);
  }

  function problema(o) {
    if (o.tipo !== 'Factura') return null;
    if (!o.RUC) return ['RUC', 'Para emitir la factura ingresa el RUC de tu empresa.'];
    if (!/^(10|15|17|20)\d{9}$/.test(o.RUC)) return ['RUC', 'El RUC debe tener 11 dígitos y empezar por 10, 15, 17 o 20.'];
    if (!rucValido(o.RUC)) return ['RUC', 'Ese RUC no es válido. Revisa que esté bien escrito.'];
    if (!o['Razón social']) return ['Razón social', 'Ingresa la razón social para la factura.'];
    if (!o['Dirección fiscal']) return ['Dirección fiscal', 'Ingresa la dirección fiscal para la factura.'];
    return null;
  }

  function limpiarError(box) {
    var e = box.querySelector('[data-fh-error]');
    if (e) { e.hidden = true; e.textContent = ''; }
    box.querySelectorAll('.fh-comp__field.is-invalid').forEach(function (f) { f.classList.remove('is-invalid'); });
  }

  function mostrarError(box, p) {
    limpiarError(box);
    var e = box.querySelector('[data-fh-error]');
    if (e) { e.textContent = p[1]; e.hidden = false; }
    var i = campo(box, p[0]);
    if (i) {
      i.closest('.fh-comp__field').classList.add('is-invalid');
      try { box.scrollIntoView({ block: 'center', behavior: 'smooth' }); } catch (_) {}
      i.focus({ preventScroll: true });
    }
  }

  function guardar(o) {
    clearTimeout(timer);
    timer = setTimeout(function () {
      var attrs = { Comprobante: o.tipo };
      KEYS.forEach(function (k) { attrs[k] = o.tipo === 'Factura' ? o[k] : ''; });
      var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
      fetch(root + 'cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ attributes: attrs })
      }).catch(function () {});
    }, 350);
  }

  function cajaDe(el) { return el && el.closest ? el.closest('[data-fh-comp]') : null; }

  document.addEventListener('change', function (ev) {
    var box = cajaDe(ev.target);
    if (!box) return;
    if (ev.target.type === 'radio') {
      aplicarTipo(box, ev.target.value);
      if (ev.target.value === 'Factura') {
        var z = box.querySelector('[data-fh-factura]');
        setTimeout(function () { try { z.scrollIntoView({ block: 'nearest', behavior: 'smooth' }); } catch (_) {} }, 50);
      }
    }
    estado = leer(box);
    guardar(estado);
  });

  document.addEventListener('input', function (ev) {
    var box = cajaDe(ev.target);
    if (!box || !ev.target.hasAttribute('data-fh-key')) return;
    if (ev.target.getAttribute('data-fh-key') === 'RUC') {
      var limpio = ev.target.value.replace(/\D/g, '').slice(0, 11);
      if (limpio !== ev.target.value) ev.target.value = limpio;
    }
    var f = ev.target.closest('.fh-comp__field');
    if (f) f.classList.remove('is-invalid');
    estado = leer(box);
    guardar(estado);
  });

  // Bloquea el paso a pagar si eligió Factura y faltan datos o el RUC no es válido
  function frenar(ev, formId) {
    var box = document.querySelector('[data-fh-comp][data-form="' + formId + '"]');
    if (!box) return;
    var p = problema(leer(box));
    if (!p) return;
    ev.preventDefault();
    ev.stopImmediatePropagation();
    mostrarError(box, p);
  }

  window.addEventListener('click', function (ev) {
    var b = ev.target.closest && ev.target.closest('button[name="checkout"], input[name="checkout"]');
    if (!b) return;
    var formId = b.getAttribute('form') || (b.form && b.form.id);
    if (formId) frenar(ev, formId);
  }, true);

  window.addEventListener('submit', function (ev) {
    var f = ev.target;
    if (!f || !f.id) return;
    var s = ev.submitter;
    if (s && s.name && s.name !== 'checkout') return;
    frenar(ev, f.id);
  }, true);

  // El carrito lateral reemplaza su HTML al actualizarse: se reaplica lo que el cliente ya escribió
  function sincronizar() {
    if (!estado) return;
    document.querySelectorAll('[data-fh-comp]:not([data-fh-sync])').forEach(function (box) {
      box.setAttribute('data-fh-sync', '');
      pintar(box, estado);
    });
  }
  var pend = false;
  new MutationObserver(function () {
    if (pend) return;
    pend = true;
    requestAnimationFrame(function () { pend = false; sincronizar(); });
  }).observe(document.documentElement, { childList: true, subtree: true });
})();
